// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"9919b96bb2735274","5809":"b7352dabb2265bf0"}[chunkId] + ".css";
};